import PropTypes from "prop-types";
import { useTimeZoneStore } from "../../stores/timeZone";
import { formatDate } from "../../utils/formatTime";

/** Keeps inline dates and saved filter labels reactive to the timezone preference. */
const DateTime = ({ value }) => {
  const timeZone = useTimeZoneStore((state) => state.timeZone);
  return formatDate(value, "DD MMM YYYY HH:mm:ss", timeZone);
};

DateTime.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default DateTime;
